import { toast } from 'react-toastify';
import moment from 'moment';
import { takeLatest, put, call, takeEvery } from 'redux-saga/effects';
import { POST } from '../../../utils/fetchWrappers';

// API URLs
import {
    API_HIERARCHY_LIST,
    APT_FETCH_MLE_LIST,
    API_GET_MERCHANT_INFO,
    API_CREATE_TID_REQUEST,
    API_GET_TERMINAL_INFO,
    API_FETCH_STATIC_URL,
    API_ENTITY_LIST1,
    API_BULK_UPLOAD_TERMINAL_ID,
} from '../../../utils/API/apiUrls';

// API Status Codes
import { apiStatusCodes } from '../../../utils/API/apiStatusCodes';

// Redux Actions
import * as loaderActions from '../../../redux/common/loader/loader.actions';

// Constants
import {
    FETCH_TID_REQUEST,
    FETCH_TID_SUCCESS,
    FETCH_TID_ERROR,
    CREATE_TID_REQUEST,
    GET_TERMINAL_INFO_REQUEST,
    FETCH_ENTITY_HIERARCHY_REQUEST,
    FETCH_STATIC_URL,
    GET_MERCHANT_INFO_REQUEST,
    FETCH_ENTITY_LIST_MERCHANT_REQUEST,
    TERMINAL_ID_BULK_UPLOAD_REQUEST,
} from './TIDOnBoard.constants';
import * as TIDActions from './TIDOnBoard.actions';

const TID_MOCK = false;

export function* fetchTIDList(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            pageNumber: payload.pageIndex,
            pageSize: payload.pageSize,
            entityType: 'TERMINAL',
            sort: 'createdOn',
            merchantId: payload.terminalId,
            name: payload.name,
            status: payload.status,
            parentEntityCode: payload.merchantId,
        };
        if (payload?.enterprise_merchant) {
            request.enterpriseMerchant =
                payload?.enterprise_merchant === 'yes' ? true : false;
        } else {
            request.enterpriseMerchant = true;
        }
        if (payload.createdOn) {
            const startDateTime = moment(payload.createdOn.startDate).format(
                'YYYY-MM-DD 00:00:00'
            );
            const endDateTime = moment(payload.createdOn.endDate).format(
                'YYYY-MM-DD 23:59:59'
            );
            delete request.createdOn;
            request.startDate = startDateTime;
            request.endDate = endDateTime;
        }

        const { data } = yield call(POST, APT_FETCH_MLE_LIST, request);

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(TIDActions.fetchTIDSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                TIDActions.fetchTIDError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(
            TIDActions.fetchTIDError({
                error: data,
            })
        );
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchMerchantInfoDetails(actions) {
    yield put(loaderActions.showLoader());

    const { toast } = actions;
    try {
        const { payload } = actions;
        const request = {
            entityCode: payload,
            entityStatus: true,
        };

        const { data } = yield call(POST, API_GET_MERCHANT_INFO, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(TIDActions.getMerchantInfoSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                TIDActions.getMerchantInfoError({
                    error: data,
                })
            );
            toast.error(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(TIDActions.getMerchantInfoError({ error: data }));
        toast.error(data.errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchTerminalInfoDetails(actions) {
    yield put(loaderActions.showLoader());
    const { history, toast } = actions;
    try {
        const { payload } = actions;
        const request = {
            entityCode: payload,
            entityStatus: true,
        };
        const { data } = yield call(POST, API_GET_TERMINAL_INFO, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(TIDActions.getTerminalInfoSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                TIDActions.getTerminalInfoError({
                    error: data,
                })
            );
            history.push('/tid-onboarding');
            toast.error(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(TIDActions.getTerminalInfoError({ error: data }));
        history.push('/tid-onboarding');
        toast.error(data.errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* createTIDRequest(actions) {
    yield put(loaderActions.showLoader());
    const { history, toast, makerId } = actions;
    try {
        const { payload } = actions;
        const eventType = payload.eventType;
        const idempotencyId = payload.idempotencyId;
        delete payload.eventType;
        delete payload.idempotencyId;

        const request = {
            makerId,
            eventType,
            idempotencyId,
            request: JSON.stringify(payload),
        };

        const { data } = yield call(POST, API_CREATE_TID_REQUEST, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            history.push('/tid-onboarding');
            toast.success('Request Initiated successfully.');
        } else if (data && data.errorMessage) {
            toast.error(data.errorMessage);
        }
    } catch ({ response }) {
        const { data } = response;
        toast.error(data.errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchHierarchyDetails(actions) {
    yield put(TIDActions.showHierarchyLoader());
    try {
        const { payload, level, entityType, onSuccess } = actions;
        console.log(actions, 'actions');

        const fetchHierarchyData = function*(entityCode, entityLevel) {
            return yield call(POST, API_HIERARCHY_LIST, {
                entityCode,
                entityLevel,
            });
        };

        const fetchParentEntityCode = data => data?.parent?.entityCode;

        const initialValue = {
            midList: [],
            mleList: [],
            fraList: [],
            mid: null,
            mle: null,
            fra: null,
            agr: null,
        };

        switch (entityType) {
            case 'MERCHANT': {
                let agr,
                    agrLowerData,
                    fra,
                    fraLowerData,
                    fraUpperData,
                    midUpperData,
                    mle,
                    mleLowerData,
                    mleUpperData;
                midUpperData = yield fetchHierarchyData(
                    payload,
                    'UPPER_COMPLETE'
                );
                let midList = [];
                let mleList = [];
                let fraList = [];

                mle = fetchParentEntityCode(midUpperData.data);
                if (mle) {
                    mleUpperData = yield fetchHierarchyData(
                        mle,
                        'UPPER_COMPLETE'
                    );
                    mleLowerData = yield fetchHierarchyData(
                        mle,
                        'LOWER_COMPLETE'
                    );
                    midList = mleLowerData.data.merchants;

                    fra = fetchParentEntityCode(mleUpperData.data);

                    if (fra) {
                        fraUpperData = yield fetchHierarchyData(
                            fra,
                            'UPPER_COMPLETE'
                        );
                        fraLowerData = yield fetchHierarchyData(
                            fra,
                            'LOWER_COMPLETE'
                        );
                        mleList = fraLowerData.data.mle;
                        agr = fetchParentEntityCode(fraUpperData.data);

                        if (agr) {
                            agrLowerData = yield fetchHierarchyData(
                                agr,
                                'LOWER_COMPLETE'
                            );
                            fraList = agrLowerData.data.franchise;
                        }
                    }
                }

                const newValue = {
                    ...initialValue,
                    midList,
                    mleList,
                    fraList,
                    mle,
                    fra,
                    agr,
                    mid: payload,
                };

                yield put(TIDActions.fetchEntityHierarchySuccess(newValue));
                break;
            }

            case 'MLE': {
                let agr,
                    agrLowerData,
                    fra,
                    fraLowerData,
                    fraUpperData,
                    midList,
                    mleLowerData,
                    mleUpperData;
                let mleList = [];
                let fraList = [];
                mleUpperData = yield fetchHierarchyData(
                    payload,
                    'UPPER_COMPLETE'
                );
                mleLowerData = yield fetchHierarchyData(
                    payload,
                    'LOWER_COMPLETE'
                );
                midList = mleLowerData.data.merchants;

                fra = fetchParentEntityCode(mleUpperData.data);

                if (fra) {
                    fraUpperData = yield fetchHierarchyData(
                        fra,
                        'UPPER_COMPLETE'
                    );
                    fraLowerData = yield fetchHierarchyData(
                        fra,
                        'LOWER_COMPLETE'
                    );
                    mleList = fraLowerData.data.mle;
                    agr = fetchParentEntityCode(fraUpperData.data);

                    if (agr) {
                        agrLowerData = yield fetchHierarchyData(
                            agr,
                            'LOWER_COMPLETE'
                        );
                        fraList = agrLowerData.data.franchise;
                    }
                }

                const newValue = {
                    ...initialValue,
                    mleList,
                    fraList,
                    midList,
                    fra,
                    agr,
                    mle: payload,
                };
                yield put(TIDActions.fetchEntityHierarchySuccess(newValue));
                break;
            }

            case 'FRANCHISE': {
                let agr, agrLowerData, fraLowerData, fraUpperData, mleList;
                let fraList = [];
                fraUpperData = yield fetchHierarchyData(
                    payload,
                    'UPPER_COMPLETE'
                );
                fraLowerData = yield fetchHierarchyData(
                    payload,
                    'LOWER_COMPLETE'
                );
                mleList = fraLowerData.data.mle;

                agr = fetchParentEntityCode(fraUpperData.data);

                if (agr) {
                    agrLowerData = yield fetchHierarchyData(
                        agr,
                        'LOWER_COMPLETE'
                    );
                    fraList = agrLowerData.data.franchise;
                }
                const newValue = {
                    ...initialValue,
                    fraList,
                    mleList,
                    agr,
                    fra: payload,
                };
                yield put(TIDActions.fetchEntityHierarchySuccess(newValue));
                break;
            }
            case 'AGGREGATOR': {
                let agrLowerData,
                    fraList = [];
                agrLowerData = yield fetchHierarchyData(
                    payload,
                    'LOWER_COMPLETE'
                );
                fraList = agrLowerData.data.franchise;

                const newValue = { ...initialValue, fraList, agr: payload };
                yield put(TIDActions.fetchEntityHierarchySuccess(newValue));
                break;
            }
            default:
                break;
        }
    } catch ({ response }) {
        const data = response && response.data;
        yield put(TIDActions.fetchEntityHierarchyError({ error: data }));
    }
    yield put(TIDActions.hideHierarchyLoader());
}

export function* fetchStaticURL(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload } = actions;
        const request = {
            merchantId: payload,
        };
        const { data } = yield call(POST, API_FETCH_STATIC_URL, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            yield put(TIDActions.fetchStaticUrlSuccess(data));
        } else if (data && data.errorMessage) {
            yield put(
                TIDActions.fetchStaticUrlError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        const { data } = response;
        yield put(TIDActions.fetchStaticUrlError({ error: data }));
    }
    yield put(loaderActions.hideLoader());
}

export function* fetchEntityListDetails(actions) {
    yield put(TIDActions.showHierarchyLoader());

    try {
        const { payload, entityData } = actions;

        const request = {
            entityType: payload && payload.toUpperCase(),
            entityName: entityData ? entityData.entityName : '',
            entityCode: entityData ? entityData.entityCode : '',
            paging: {
                pageNumber: 1,
                pageSize: 500,
            },
        };

        const { data } = yield call(POST, API_ENTITY_LIST1, request);
        if (data && data.statusCode === apiStatusCodes.SUCCESS2) {
            const values = {};
            values[payload.toLowerCase()] = data && data.entities;

            if (entityData) {
                yield put(
                    TIDActions.fetchEntityListSuccessAddList(
                        values,
                        payload.toLowerCase()
                    )
                );
            } else {
                yield put(TIDActions.fetchEntityListSuccess(values));
            }
        } else if (data && data.errorMessage) {
            yield put(
                TIDActions.fetchEntityListError({
                    error: data,
                })
            );
        }
    } catch ({ response }) {
        console.log(response, 'request catch');
        const data = response && response.data;
        yield put(TIDActions.fetchEntityListError({ error: data }));
    }
    yield put(TIDActions.hideHierarchyLoader());
}

const bulkUploadResponse = {
    success: {
        statusCode: '200',
        errorMessage: 'Upload Success',
        requestId: 'abc123xyz',
    },
    error: {
        statusCode: '400',
        errorMessage: 'Invalid request parameters',
        requestId: '',
    },
};

export function* terminalIDBulkUpload(actions) {
    yield put(loaderActions.showLoader());
    try {
        const { payload, handleSuccess, handleError } = actions;

        let data = {};
        if (TID_MOCK) {
            data = bulkUploadResponse.success;
        } else {
            const response = yield call(
                POST,
                API_BULK_UPLOAD_TERMINAL_ID,
                payload,
                {
                    'Content-Type': 'multipart/form-data;',
                },
                true
            );
            data = response.data;
        }

        if (data && data.statusCode === apiStatusCodes.SUCCESS) {
            handleSuccess(data);
        } else if (data && data.errorMessage) {
            handleError(data);
        }
    } catch ({ response }) {
        toast.error(response.errorMessage);
    }
    yield put(loaderActions.hideLoader());
}

export function* tidSagas() {
    yield takeLatest(FETCH_TID_REQUEST, fetchTIDList);
    yield takeLatest(GET_MERCHANT_INFO_REQUEST, fetchMerchantInfoDetails);
    yield takeLatest(CREATE_TID_REQUEST, createTIDRequest);
    yield takeLatest(GET_TERMINAL_INFO_REQUEST, fetchTerminalInfoDetails);
    yield takeLatest(FETCH_ENTITY_HIERARCHY_REQUEST, fetchHierarchyDetails);
    yield takeLatest(FETCH_STATIC_URL, fetchStaticURL);
    yield takeEvery(FETCH_ENTITY_LIST_MERCHANT_REQUEST, fetchEntityListDetails);
    yield takeLatest(TERMINAL_ID_BULK_UPLOAD_REQUEST, terminalIDBulkUpload);
}
